var React = require('react');

function IconArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M28 16l-2.115-2.115-8.385 8.37V4h-3v18.255L6.13 13.87 4 16l12 12z","transform":"translate(-4 -4)"}));
}

IconArrowDown.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconArrowDown;

IconArrowDown.default = IconArrowDown;
